import styled from 'styled-components';
import { theme } from '../layout/theme';

export const DropdownHeader = styled.div`
  display: block;
  transition: all 100ms linear;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  width: 100%;
  height: 48px;
  padding: 11px 16px;
  background: #ffffff;
  text-align: left;
  cursor: pointer;

  &.disabled {
    background-color: #fafafa;
    cursor: default;
  }
`;

export const DropdownItem = styled.li`
  display: grid;
  grid-template-columns: 0 1fr;
  grid-gap: 2.75em;
  align-items: center;
  font-size: 1rem;
  line-height: 1.25;
  min-height: 40px;
  cursor: pointer;
  &:hover {
    background-color: ${theme.colors.bg.accent};
  }
  ${theme.screens.LtMd} {
    font-size: 1.2rem;
  }
`;

export const DropdownIcon = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const CheckIconWrapper = styled.div`
  color: ${theme.colors.text.link};
  padding-left: 15px;
`;

export const DropdownList = styled.ul`
  padding: 0;
  overflow: hidden;
  width: 88px;
  ${theme.screens.LtMd} {
    width: 100%;
  }
`;
